import {observer} from "mobx-react";
import {ISvgIconProps} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import {GameNavBarButtonBox} from "./boxes/button/game-nav-bar-button.box";
import {GameNavBarButtonLabelBox} from "./boxes/button/label/game-nav-bar-button-label.box";

interface IGameNavBarItemComponentProps {
    Icon: React.ComponentType<ISvgIconProps>;
    text: string;
    labelSmallSize?: boolean;
    onClick(): void;
}

export const GameNavBarItemMobileComponent: React.FC<IGameNavBarItemComponentProps> = observer((props) => {
    const IconComponent = props.Icon;
    return <GameNavBarButtonBox onClick={props.onClick}>
        <IconComponent size={1.8} style={{margin: "0 auto"}} />
        <GameNavBarButtonLabelBox smallSize={props.labelSmallSize}>{props.text}</GameNavBarButtonLabelBox>
    </GameNavBarButtonBox>;
});
